import { displayNameSchema } from "@klass-share/protocol";

import { strings } from "./strings.js";

export interface ValidDisplayName {
  ok: true;
  value: string;
}

export interface InvalidDisplayName {
  ok: false;
  message: string;
}

export type DisplayNameResult = ValidDisplayName | InvalidDisplayName;

/** Uses the normative protocol schema so UI, E2E, and wire validation cannot drift. */
export function validateDisplayName(value: string): DisplayNameResult {
  const result = displayNameSchema.safeParse(value);
  if (result.success) return { ok: true, value: result.data };
  const issue = result.error.issues[0]?.message ?? "displayName is invalid";
  return { ok: false, message: displayNameMessage(issue) };
}

export function requireValidDisplayName(value: string): string {
  const result = validateDisplayName(value);
  if (!result.ok) throw new DisplayNameValidationError(result.message);
  return result.value;
}

export class DisplayNameValidationError extends Error {
  public constructor(message: string) {
    super(message);
    this.name = "DisplayNameValidationError";
  }
}

function displayNameMessage(issue: string): string {
  if (issue.includes("reserved host name")) {
    return strings.errors.displayName.reservedHost;
  }
  if (issue.includes("1 to 64 Unicode code points")) {
    return strings.errors.displayName.codePointLength;
  }
  if (issue.includes("256 UTF-8 bytes")) {
    return strings.errors.displayName.utf8Length;
  }
  return strings.errors.displayName.invalid;
}
